<template>
  <div class="add-new-user">
    <h1 class="page-header color-1-100">Create a new industry account</h1>
    <div class="admin-breadcrumbs">
      <router-link class="dashboard background-1-20 color-2-100" to="/">Go to Dashboard</router-link>
      <router-link class="all-users background-1-20 color-2-100" :to="{name: 'industries'}">Back to all industries list</router-link>
    </div>
    <div class="flex-block">
      <div class="content-left-section">
        <div class="content-section content-section__bordered border-1-20 add-user-section no-margin-top" ref="industryDetails">
          <div>
            <div class="add-new-user-form">
              <h3 class="content-section-title color-1-100 background-1-100-before">Industry details</h3>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="new-industry-name" class="form-label color-2-63">Industry name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Industry name') } ]"
                         v-model="newIndustry.name"
                         data-lpignore="true"
                         id="new-industry-name"
                         v-validate="'required'"
                         name="Industry name">
                  <span class="form-field-error" v-if="this.errors.has('Industry name')">{{ this.errors.first('Industry name') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="new-industry-parent" class="form-label color-2-63">Parent industry</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :searchable = true
                            v-model="newIndustry.parent"
                            :options="preparedIndustries"
                            data-vv-name="Parent industry"
                            data-lpignore="true"
                            :class="[{ 'has-error': errors.has('Parent industry') }]"
                            name="Industry status"
                            id="new-industry-parent" />
                  <span class="form-field-error" v-if="this.errors.has('Parent industry')">{{ this.errors.first('Parent industry') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="content-section content-section__bordered border-1-20 add-user-section" ref="industryBenchmark">
          <div>
            <div class="add-new-user-form">
              <h3 class="content-section-title color-1-100 background-1-100-before">Benchmark</h3>
              <div class="form-group">
                <div class="form-element">
                  <table class="benchmark-table">
                    <thead>
                      <tr>
                        <th>Policies and procedures</th>
                        <th>Finding talent</th>
                        <th>Accessing talent</th>
                        <th>Retaining talent</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div>
                            <input title="Policies and procedures benchmark"
                                   type="number"
                                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                                   min="0"
                                   max="100"
                                   v-model="newIndustry.benchmarkPoliciesAndProcedures"
                                   data-lpignore="true">
                          </div>
                        </td>
                        <td>
                          <div>
                            <input title="Finding talent benchmark"
                                   type="number"
                                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                                   min="0"
                                   max="100"
                                   v-model="newIndustry.benchmarkFindingTalent"
                                   data-lpignore="true">
                          </div>
                        </td>
                        <td>
                          <div>
                            <input title="Accessing talent benchmark"
                                   type="number"
                                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                                   min="0"
                                   max="100"
                                   v-model="newIndustry.benchmarkAccessingTalent"
                                   data-lpignore="true">
                          </div>
                        </td>
                        <td>
                          <div>
                            <input title="Retaining talent benchmark"
                                   type="number"
                                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                                   min="0"
                                   max="100"
                                   v-model="newIndustry.benchmarkRetainingTalent"
                                   data-lpignore="true">
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="content-section content-section__bordered border-1-20 profile-section" ref="industryChapters">
          <article class="personal-info">
            <h3 class="content-section-title color-1-100 background-1-100-before">Task categories</h3>
            <div class="form-group form-group-half">
              <div class="form-element">
                <label for="new-industry-chapter-pp" class="form-label color-2-63">Policies and procedures</label>
                <v-select
                  class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple"
                  id="new-industry-chapter-pp"
                  :debounce="250"
                  :on-search="getOptionsThingsToConsider"
                  :options="thingsToConsiderOptions"
                  :multiple="false"
                  v-model="newIndustry.chapterPoliciesAndProcedures"
                  placeholder="Search..." />
              </div>
              <div class="form-element">
                <label for="new-industry-chapter-ft" class="form-label color-2-63">Finding talent</label>
                <v-select
                  class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple"
                  id="new-industry-chapter-ft"
                  :debounce="250"
                  :on-search="getOptionsThingsToConsider"
                  :options="thingsToConsiderOptions"
                  :multiple="false"
                  v-model="newIndustry.chapterFindingTalent"
                  placeholder="Search..." />
              </div>
            </div>
            <div class="form-group form-group-half">
              <div class="form-element">
                <label for="new-industry-chapter-at" class="form-label color-2-63">Assessing talent</label>
                <v-select
                  class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple"
                  id="new-industry-chapter-at"
                  :debounce="250"
                  :on-search="getOptionsThingsToConsider"
                  :options="thingsToConsiderOptions"
                  :multiple="false"
                  v-model="newIndustry.chapterAccessingTalent"
                  placeholder="Search..." />
              </div>
              <div class="form-element">
                <label for="new-industry-chapter-rt" class="form-label color-2-63">Retaining talent</label>
                <v-select
                  class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple"
                  id="new-industry-chapter-rt"
                  :debounce="250"
                  :on-search="getOptionsThingsToConsider"
                  :options="thingsToConsiderOptions"
                  :multiple="false"
                  v-model="newIndustry.chapterRetainingTalent"
                  placeholder="Search..." />
              </div>
            </div>
          </article>
          <div class="clearfix"></div>
        </div>
        <div class="content-section content-section__bordered border-1-20 add-user-section" ref="industrySponsors">
          <div>
            <div class="add-new-user-form">
              <h3 class="content-section-title color-1-100 background-1-100-before no-bottom-margin">Add sponsors</h3>
              <div class="form-group">
                <div class="sponsor-list" v-sortable :options="newIndustry.sponsors">
                  <div class="sponsor-item" v-for="(row, index) in newIndustry.sponsors">
                    <div class="sponsor-item-handle"></div>
                    <div class="sponsor-item-logo" :id="'uploadLogo-' + index">
                      <div v-bind:style="{ backgroundImage: 'url(' + row.logo + ')' }"
                           class="sponsor-item-logo__image" v-if="row.isLogoFileUploaded === true && row.logo !== ''"></div>
                      <input class="hidden" style="display: none" v-model="row.order = index + 1" />
                      <label :for="'uploadInput-' + index" class="form-label color-2-63 form-label__logo-upload" v-show="row.isLogoFileUploaded === false">
                        +Upload logo
                        <input
                                type="file"
                                :id="'uploadInput-' + index"
                                name="Thumbnail"
                                data-vv-as='"Thumbnail"'
                                v-if="row.isLogoFileUploaded === false"
                                value.sync="row.logo"
                                placeholder="+Upload logo"
                                v-validate.reject="veeValidateFileUploadRules"
                                @change="onThumbnailFileChange($event, index)"
                                class="form-control form-control--file" />
                      </label>
                      <div class="sponsor-item-logo__remove"
                           v-on:click="removeLogo(index)"
                           v-if="row.isLogoFileUploaded === true"></div>
                    </div>
                    <div class="sponsor-item-alt">
                      <input title="Image alt"
                             type="text"
                             class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                             v-model="row.alt"
                             v-on:input="addNewRow(index)"
                             placeholder="Alt"
                             data-lpignore="true">
                    </div>
                    <div class="sponsor-item-url">
                      <input title="Sponsor url"
                             type="text"
                             class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                             v-model="row.url"
                             v-on:input="addNewRow(index)"
                             placeholder="Url"
                             data-lpignore="true">
                    </div>
                    <div class="sponsor-item-remove" v-on:click="removeElement(index)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right-section anchors">
        <div class="sticky-anchors background-1-40-before">
          <div class="anchor-item color-1-20 details-2" :class="[{ 'active  color-1-100': activeSection === 'industryDetails' }]">
            <button @click.prevent="goToPageSection('industryDetails')">Industry details</button>
          </div>
          <div class="anchor-item color-1-20 benchmark" :class="[{ 'active  color-1-100': activeSection === 'industryBenchmark' }]">
            <button @click.prevent="goToPageSection('industryBenchmark')">Benchmark</button>
          </div>
          <div class="anchor-item color-1-20 benchmark" :class="[{ 'active  color-1-100': activeSection === 'industryChapters' }]">
            <button @click.prevent="goToPageSection('industryChapters')">Task categories</button>
          </div>
          <div class="anchor-item color-1-20 sponsors" :class="[{ 'active  color-1-100': activeSection === 'industrySponsors' }]">
            <button @click.prevent="goToPageSection('industrySponsors')">Add sponsors</button>
          </div>
        </div>
      </div>
    </div>
    <div class="add-new-user-control-panel">
      <button type="button" v-on:click.prevent="discardAllData()" class="clear-form" style="width: 280px;">Cancel, discard all data</button>
      <button type="button" v-on:click.prevent="createNewIndustry()" class="submit-user" style="width: 280px;">Save changes</button>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapGetters, mapActions } from 'vuex'
  import AppSelect from '@/components/admin/common/Select'
  import Vue from 'vue'
  import Sortable from 'sortablejs'
  import _ from 'lodash'

  Vue.directive('sortable', {
    inserted: function (el, binding) {
      Sortable.create(el, binding.value || {
        handle: '.sponsor-item-handle'
      })
    }
  })

  export default {
    name: 'add-industry',
    data () {
      return {
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        industry: null,
        lastEdited: null,
        newIndustry: {
          name: '',
          parent: null,
          benchmarkPoliciesAndProcedures: '',
          benchmarkFindingTalent: '',
          benchmarkAccessingTalent: '',
          benchmarkRetainingTalent: '',
          chapterPoliciesAndProcedures: '',
          chapterFindingTalent: '',
          chapterAccessingTalent: '',
          chapterRetainingTalent: '',
          sponsors: [
            {
              id: null,
              logo: '',
              alt: '',
              url: '',
              order: 0,
              isLogoFileUploaded: false
            }
          ]
        },
        serverValidation: {
          errors: []
        },
        disableAPI: false,
        confirmation: {
          action: '',
          isShown: false,
          id: null,
          style: {
            top: '100px'
          }
        },
        activeSection: 'industryDetails',
        thingsToConsiderOptions: []
      }
    },
    computed: {
      ...mapGetters([
        'getIndustriesForSelect'
      ]),
      preparedIndustries () {
        let industryList = []
        for (let industry in this.getIndustriesForSelect) {
          if (this.getIndustriesForSelect[industry].parent !== 1) {
            industryList.push(this.getIndustriesForSelect[industry])
          }
        }
        return industryList
      }
    },
    methods: {
      ...mapActions([
        'getIndustries',
        'setInformationMsg'
      ]),
      getOptionsThingsToConsider (search, loading) {
        loading(true)
        let urlString = `${api.URLS.search}&search=${search}&isArticle=true`
        this.$http.get(urlString, api.headersAuthSettings)
          .then((res) => {
            console.log(res)
            let items = res.body.data.items ? res.body.data.items : []
            this.thingsToConsiderOptions = items.map(item => {
              let industries = item.industries.map(item2 => {
                return item2.name
              })
              industries = industries.length ? ' (' + industries.join(', ') + ')' : ''
              return {
                value: item.id,
                label: item.title + industries
              }
            })
            loading(false)
          })
          .catch((err) => {
            console.log(err)
            loading(false)
          })
      },
      createNewIndustry () {
        this.$validator.validateAll()
        let self = this
        if (this.errors.items.length) return
        if (this.newIndustry.name === '') return
        let sponsors = []
        for (let sponsor in this.newIndustry.sponsors) {
          if (this.newIndustry.sponsors[sponsor].logo !== '') {
            sponsors.push({
              logo: this.newIndustry.sponsors[sponsor].logo,
              alt: this.newIndustry.sponsors[sponsor].alt,
              url: this.newIndustry.sponsors[sponsor].url,
              order: this.newIndustry.sponsors[sponsor].order
            })
          }
        }
        let industryData = {
          industryName: this.newIndustry.name,
          parent: this.newIndustry.parent,
          // benchmark
          benchmarkFindingTalent: this.newIndustry.benchmarkFindingTalent,
          benchmarkPoliciesAndProcedures: this.newIndustry.benchmarkPoliciesAndProcedures,
          benchmarkAccessingTalent: this.newIndustry.benchmarkAccessingTalent,
          benchmarkRetainingTalent: this.newIndustry.benchmarkRetainingTalent,
          chapterFindingTalent: this.newIndustry.chapterFindingTalent,
          chapterPoliciesAndProcedures: this.newIndustry.chapterPoliciesAndProcedures,
          chapterAccessingTalent: this.newIndustry.chapterAccessingTalent,
          chapterRetainingTalent: this.newIndustry.chapterRetainingTalent,
          // sponsors
          sponsors: sponsors
        }
        this.$http.put(api.URLS.industry, industryData, api.headersAuthSettings)
            .then((res) => {
              self.discardAllData()
              self.goToIndustryList()
              this.infMsgTitle = 'A new industry called ' + res.body.name + ' was successfully created.'
              this.infMsgDescription = 'Now you can assign companies and content to this industry.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
            })
            .catch((err) => {
              this.serverValidation.errors = err.body
              this.infMsgTitle = 'Error. We were not able to create this industry because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
            })
      },
      discardAllData () {
        let self = this
        this.newIndustry = {
          name: '',
          parent: null,
          benchmark: {
            policiesAndProcedures: '',
            findingTalent: '',
            accessingTalent: '',
            retainingTalent: ''
          },
          sponsors: [
            {
              id: null,
              logo: '',
              alt: '',
              url: '',
              order: 0,
              isLogoFileUploaded: false
            }
          ]
        }
        setTimeout(function () {
          self.errors.clear()
        }, 1)
      },
      closeMsg: function () {
        this.errors.clear()
      },
      addNewRow: function (index) {
        if (this.newIndustry.sponsors.length - 1 === index) {
          this.newIndustry.sponsors.push({
            id: null,
            logo: '',
            alt: '',
            url: '',
            order: index + 1,
            isLogoFileUploaded: false
          })
        }
      },
      removeElement: function (index) {
        if (this.newIndustry.sponsors.length === 1) {
          this.newIndustry.sponsors = [
            {
              id: null,
              logo: '',
              alt: '',
              url: '',
              order: 0,
              isLogoFileUploaded: false
            }
          ]
        } else {
          this.newIndustry.sponsors.splice(index, 1)
        }
      },
      veeValidateFileUploadRules () {
        return {
          required: true,
          mimes: 'image/*'
        }
      },
      onThumbnailFileChange (e, index) {
        let self = this
        let input = document.getElementById(e.target.id)
        let thisItem = input.closest('.sponsor-item')
        if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
          let reader = new FileReader()
          reader.onloadstart = function () {
            thisItem.classList.add('loading')
          }
          reader.onload = function (e) {
            self.newIndustry.sponsors[index].logo = e.target.result
            self.newIndustry.sponsors[index].isLogoFileUploaded = true
            if (self.newIndustry.sponsors.length - 1 === index) {
              self.newIndustry.sponsors.push({
                id: null,
                logo: '',
                alt: '',
                url: '',
                order: index + 1,
                isLogoFileUploaded: false
              })
            }
          }
          reader.readAsDataURL(input.files[0])
          reader.onloadend = function () {
            if (this.readyState === 2) {
              thisItem.classList.remove('loading')
            }
          }
        }
      },
      removeLogo (index) {
        this.newIndustry.sponsors[index].isLogoFileUploaded = false
        this.newIndustry.sponsors[index].logo = ''
      },
      goToIndustryList () {
        let props = this.$router.resolve({
          name: 'industries'
        })
        this.$router.push(props.href)
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          let here = element[0] ? element[0] : element
          here.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      },
      posY (elm) {
        let test = elm[0] ? elm[0] : elm
        let top = 0
        if (test && test.tagName) {
          while (test !== null && test.tagName.toLowerCase() !== 'body') {
            top += test.offsetTop
            test = test.offsetParent
          }
        }
        return top
      },
      scrollY () {
        if (window.pageYOffset) {
          return window.pageYOffset
        }
        return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      },
      isScrolledIntoView (el) {
        let elem = el[0] ? el[0] : el
        let docViewTop = this.scrollY()
        let docViewBottom = docViewTop + window.outerHeight
        let elemTop = this.posY(elem) + 300
        let elemBottom = elemTop + elem.offsetHeight
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
      },
      handleScroll () {
        let sections = this.$refs
        for (let index in sections) {
          if (!index.match(/article/)) {
            let section = sections[index]
            if (section && this.isScrolledIntoView(section)) {
              this.activeSection = index
            }
          }
        }
      }
    },
    watch: {},
    components: {
      AppSelect
    },
    beforeMount () {
      this.getIndustries()
    },
    created: function () {
      this.newIndustry.sponsors = _.orderBy(this.newIndustry.sponsors, 'order')
      window.addEventListener('scroll', this.handleScroll)
      document.title = 'Create a new industry account | Clear Assured'
      if (window._paq) {
        window._paq.push(['setCustomUrl', location.pathname])
        window._paq.push(['setDocumentTitle', document.title])
        window._paq.push(['trackPageView'])
      }
      // if (window.ga) {
      //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      //   window.ga('send', 'pageview', {
      //     'page': location.pathname,
      //     'location': location.href,
      //     'title': document.title
      //   })
      // }
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style src='@/assets/scss/components/add-industry.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// AddIndustry.vue?9e1d8a3c